export const isMobile = () => {
  if (
    window.innerWidth > 768 &&
    !window.navigator.userAgent.includes("Mobile")
  ) {
    return false;
  }
  return /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    window.navigator.userAgent
  );
};

export const isIos = () => {
  return (
    /iPhone|iPad|iPod/i.test(window.navigator.userAgent) ||
    /iPad|iPhone|iPod/.test(navigator.platform) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
  );
};
